import { List, fromJS } from "immutable";
import { combineReducers } from "redux";

import {
  SET_EVENT_TYPES,
  SET_INDUSTRIES,
  SET_ORGANIZATION_TYPES,
  SET_USER_HUB_ROLE_TYPES,
  SET_USER_PROJECT_ROLE_TYPES,
  SET_USER_EVENT_ROLE_TYPES,
  SET_TOPIC_SECTIONS,
} from "./appDataActions";

const initIndustries = List();
export function industries(state = initIndustries, action) {
  switch (action.type) {
    case SET_INDUSTRIES: {
      return initIndustries.concat(fromJS(action.data));
    }
    default:
      return state;
  }
}

const initTopicSections = List();
export function topicSections(state = initTopicSections, action) {
  switch (action.type) {
    case SET_TOPIC_SECTIONS:
      return List(fromJS(action.data));
    default:
      return state;
  }
}

const initUserProjectRoleTypes = List();
export function userProjectRoleTypes(state = initUserProjectRoleTypes, action) {
  switch (action.type) {
    case SET_USER_PROJECT_ROLE_TYPES:
      return initUserProjectRoleTypes.concat(fromJS(action.data));
    default:
      return state;
  }
}

const initOrganizationTypes = List();
export function organizationTypes(state = initOrganizationTypes, action) {
  switch (action.type) {
    case SET_ORGANIZATION_TYPES:
      return List().concat(fromJS(action.data));
    default:
      return state;
  }
}

export function userHubRoleTypes(state = List(), action) {
  switch (action.type) {
    case SET_USER_HUB_ROLE_TYPES:
      return List().concat(fromJS(action.data));
    default:
      return state;
  }
}

export function eventTypes(state = List(), action) {
  switch (action.type) {
    case SET_EVENT_TYPES:
      return List().concat(fromJS(action.data));
    default:
      return state;
  }
}

export function userEventRoleTypes(state = List(), action) {
  switch (action.type) {
    case SET_USER_EVENT_ROLE_TYPES:
      return List().concat(fromJS(action.data));
    default:
      return state;
  }
}

export default combineReducers({
  eventTypes,
  industries,
  organizationTypes,
  topicSections,
  userEventRoleTypes,
  userHubRoleTypes,
  userProjectRoleTypes,
});
